<template>
    <div class="nc-contact" :class="{ 'nc-contact_urgent': item.sign_of_urgency }" @click="$emit('click', item)">
        <div class="nc-contact__img">
            <img v-if="item.icon && item.icon !== 'default'" :src="item.icon" :alt="item.client_info" />
            <img v-else-if="item.icon === 'default'" src="/images/chat/whatsapp_sendpulse.png" :alt="item.client_info" />
            <div v-else class="nc-contact__img-fallback">
                <svg aria-hidden="true" width="24" height="24">
                    <use href="#icon-chat"></use>
                </svg>
            </div>
        </div>

        <div class="nc-contact__body">
            <div class="nc-contact__row">
                <span class="nc-contact__name">{{ item.client_info }}</span>
                <span class="nc-contact__date">{{ item.date_created }}</span>
            </div>
            <div class="nc-contact__row">
                <span class="nc-contact__message">{{ item.message || '&nbsp;' }}</span>
                <span v-if="item.sign_of_urgency" class="nc-contact__urgent-badge">Срочно</span>
                <span v-if="item.count_unread" class="nc-contact__counter">
                    {{ item.count_unread < 100 ? item.count_unread : '99+' }}
                </span>
            </div>
            <div v-if="item.type === 'request_from_ai'" class="nc-contact__alert">
                <svg width="12" height="12" aria-hidden="true"><use href="#icon-warning-cercle"></use></svg>
                Запросили помощь оператора
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NewChatContactItem',
    props: {
        item: {
            type: Object,
            required: true
        }
    }
}
</script>
